<template>
    <b-modal
        v-model="modalShow"
        size="md"
        hide-header
        hide-footer
        @hidden="close">
        <div class="modal-body">
            <div
                v-if="consultation !== null"
                class="RepeatConsultationDeleteWrapper">
                <h1 class="RepeatConsultationDeleteHeader">{{ headerFormat }}</h1>

                <div class="doctorMenu">
                    <template v-if="consultation.doctor_menu !== null">
                        <doctor-menu-base-info
                            :menu="consultation.doctor_menu"
                            :user="user"
                            :is-draft="isDraft"
                            :is-draft-by-doctor="isDraftByDoctor">
                        </doctor-menu-base-info>

                        <hr class="divide">

                        <doctor-info
                            :doctor="consultation.doctor_menu.doctor"
                            :user="user"
                            :early-schedule="consultation.doctor_menu.early_schedule">
                        </doctor-info>
                    </template>
                    <template v-else>
                        <doctor-menu-base-info
                            :menu="helper.matchingDoctorMenu(consultation.medical_course)"
                            :user="user"
                            is-draft>
                        </doctor-menu-base-info>
                        <div class="descriptionWrapper descriptionWrapperExtended mt-1">
                            <div class="description">{{ helper.matchingDoctorMenuDesc() }}</div>
                        </div>
                    </template>
                </div>

                <div class="d-flex justify-content-center align-items-center mt-4 pt-2">
                    <b-button
                        size="md"
                        variant="yokumiru-gray"
                        class="mr-3"
                        :disabled="inProgress"
                        @click="close">
                        キャンセル
                    </b-button>
                    <b-button
                        size="md"
                        variant="danger"
                        class="ml-3"
                        :disabled="inProgress"
                        @click="submit">
                        削除する
                    </b-button>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
import constants from '../../../constants'
import YokumiruHelper from '../../../YokumiruHelper'

export default {
    props: {
        user: {
            type: Object,
            required: true,
        },
    },

    data: function () {
        return {
            helper: YokumiruHelper,
            inProgress: false,
            modalShow: false,
            consultation: null
        }
    },

    computed: {
        /**
         * 再相談card判定: ドラフト予約
         */
        isDraft: function () {
            if (!this.consultation) return false
            return this.consultation.is_draft && this.consultation.flg_cancel
        },

        /**
         * 再相談card判定: 医師によるドラフト予約
         */
        isDraftByDoctor: function () {
            if (!this.consultation) return false
            return this.consultation.is_draft && ! this.consultation.flg_cancel
        },

        headerFormat: function () {
            if (this.isDraft) {
                return `予約未完了の${this.$locale.consultation_host}予約を削除しますか？`
            }
            if (this.isDraftByDoctor) {
                return `医師が追加した${this.$locale.consultation_host}予約を削除しますか？`
            }
        },
    },

    created: function () {
        bus.$on('open-modal-user-draft-delete', this.open)
    },

    beforeDestroy: function () {
        bus.$off('open-modal-user-draft-delete')
    },

    methods: {
        /**
         * モーダル表示
         * @param {object} consultation
         */
        open: function (consultation) {
            this.consultation = consultation
            this.modalShow = true
        },

        /**
         * モーダル非表示
         */
        close: function () {
            this.modalShow = false
        },

        /**
         * 利用アカウント発行（新規）
         */
        submit: async function () {
            if (this.inProgress) return
            this.inProgress = true

            const endpoint = constants.user.consultations.endpoint.base

            await axios.delete(`${endpoint}/${this.consultation.id}/draft`)
                .then(() => {
                    bus.$emit('alert-success', '削除しました。')
                    bus.$emit('user-draft-deleted')
                    this.close()
                })
                .catch(({response}) => {
                    if (response &&
                        response.hasOwnProperty('data') &&
                        response.data.hasOwnProperty('errors')) {
                        bus.$emit('alert-danger')
                        this.errors = response.data.errors
                    }
                    else {
                        bus.$emit('alert-danger', 'システムエラーが発生しました。')
                    }
                })

            this.inProgress = false
        },
    },
}
</script>

<style scoped lang="scss">
.RepeatConsultationDeleteHeader {
    margin-bottom: 20px;
    color: #251E1C;
    font-size: 18px;
    text-align: center;
}

.doctorMenu {
    position: relative;
    vertical-align: top;
    width: 100%;
    margin-bottom: 10px;
    padding: 20px 25px;
    background-color: #f9f9f9;
    border: 1px solid #dee2e6;
    border-radius: 6px;

    @media screen and (max-width: 1280px) {
        max-width: 100%;
    }
}
</style>
